// @flow
import * as React from 'react'

export const GooglepayIcon = (props: any) => (
  <svg
    id="G_Pay_Acceptance_Mark"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 956.9 604.9"
    style={{
      enableBackground: 'new 0 0 956.9 604.9',
      height: 30,
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style>{'.st1{fill:#3c4043}'}</style>
    <path
      id="Base_1_"
      d="M654.4 102.4h-352c-110 0-200 90-200 200s90 200 200 200h352c110 0 200-90 200-200s-90-200-200-200z"
      style={{
        fill: '#fff',
      }}
    />
    <path
      id="Outline"
      className="st1"
      d="M654.4 118.6c24.7 0 48.7 4.9 71.3 14.5 21.9 9.3 41.5 22.6 58.5 39.5 16.9 16.9 30.2 36.6 39.5 58.5 9.6 22.6 14.5 46.6 14.5 71.3s-4.9 48.7-14.5 71.3c-9.3 21.9-22.6 41.5-39.5 58.5-16.9 16.9-36.6 30.2-58.5 39.5-22.6 9.6-46.6 14.5-71.3 14.5h-352c-24.7 0-48.7-4.9-71.3-14.5-21.9-9.3-41.5-22.6-58.5-39.5-16.9-16.9-30.2-36.6-39.5-58.5-9.6-22.6-14.5-46.6-14.5-71.3s4.9-48.7 14.5-71.3c9.3-21.9 22.6-41.5 39.5-58.5 16.9-16.9 36.6-30.2 58.5-39.5 22.6-9.6 46.6-14.5 71.3-14.5h352m0-16.2h-352c-110 0-200 90-200 200s90 200 200 200h352c110 0 200-90 200-200s-90-200-200-200z"
    />
    <g id="G_Pay_Lockup_1_">
      <g id="Pay_Typeface_3_">
        <path
          id="Letter_p_3_"
          className="st1"
          d="M461 316.6v60.5h-19.2V227.7h50.9c12.9 0 23.9 4.3 32.9 12.9 9.2 8.6 13.8 19.1 13.8 31.5 0 12.7-4.6 23.2-13.8 31.7-8.9 8.5-19.9 12.7-32.9 12.7H461v.1zm0-70.5v52.1h32.1c7.6 0 14-2.6 19-7.7 5.1-5.1 7.7-11.3 7.7-18.3 0-6.9-2.6-13-7.7-18.1-5-5.3-11.3-7.9-19-7.9H461v-.1z"
        />
        <path
          id="Letter_a_3_"
          className="st1"
          d="M589.6 271.5c14.2 0 25.4 3.8 33.6 11.4 8.2 7.6 12.3 18 12.3 31.2v63h-18.3v-14.2h-.8c-7.9 11.7-18.5 17.5-31.7 17.5-11.3 0-20.7-3.3-28.3-10s-11.4-15-11.4-25c0-10.6 4-19 12-25.2 8-6.3 18.7-9.4 32-9.4 11.4 0 20.8 2.1 28.1 6.3v-4.4c0-6.7-2.6-12.3-7.9-17-5.3-4.7-11.5-7-18.6-7-10.7 0-19.2 4.5-25.4 13.6l-16.9-10.6c9.3-13.5 23.1-20.2 41.3-20.2zm-24.8 74.2c0 5 2.1 9.2 6.4 12.5 4.2 3.3 9.2 5 14.9 5 8.1 0 15.3-3 21.6-9s9.5-13 9.5-21.1c-6-4.7-14.3-7.1-25-7.1-7.8 0-14.3 1.9-19.5 5.6-5.3 3.9-7.9 8.6-7.9 14.1z"
        />
        <path
          id="Letter_y_3_"
          className="st1"
          d="m739.9 274.8-64 147.2h-19.8l23.8-51.5-42.2-95.7h20.9l30.4 73.4h.4l29.6-73.4h20.9z"
        />
      </g>
      <g id="G_Mark_1_">
        <path
          id="Blue_500"
          d="M384.7 304.4c0-6.3-.6-12.2-1.6-18h-80.5v33H349c-1.9 11-7.9 20.3-17.2 26.6v21.4h27.6c16-14.9 25.3-36.9 25.3-63z"
          style={{
            fill: '#4285f4',
          }}
        />
        <path
          id="Green_500_1_"
          d="M331.7 346c-7.7 5.2-17.6 8.2-29.1 8.2-22.4 0-41.3-15.1-48.1-35.4H226v22.1c14.1 28 43.1 47.2 76.6 47.2 23.1 0 42.6-7.6 56.7-20.7L331.7 346z"
          style={{
            fill: '#34a853',
          }}
        />
        <path
          id="Yellow_500_1_"
          d="M251.8 302.5c0-5.7 1-11.2 2.7-16.4V264H226c-5.8 11.6-9.1 24.6-9.1 38.5s3.3 26.9 9.1 38.5l28.5-22.1c-1.7-5.2-2.7-10.7-2.7-16.4z"
          style={{
            fill: '#fabb05',
          }}
        />
        <path
          id="Red_500"
          d="M302.6 250.7c12.6 0 23.9 4.4 32.9 12.9l24.5-24.4c-14.9-13.8-34.2-22.3-57.3-22.3-33.5 0-62.5 19.2-76.6 47.2l28.5 22.1c6.7-20.4 25.7-35.5 48-35.5z"
          style={{
            fill: '#e94235',
          }}
        />
      </g>
    </g>
  </svg>
)

export const ApplepayIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 223.5 165.32"
    style={{
      enableBackground: 'new 0 0 223.5 165.32',
      height: 30,
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path d="M179.33 29.63H41.75c-.48 0-.95.01-1.43.02-1.04.03-2.09.09-3.11.27-1.04.19-2.01.49-2.96.98-.93.47-1.78 1.09-2.52 1.83s-1.36 1.59-1.83 2.52c-.48.95-.79 1.92-.97 2.96-.19 1.03-.25 2.07-.28 3.11-.01.48-.02.95-.02 1.43v79.72c0 .48.01.95.02 1.43.03 1.04.09 2.08.28 3.11.19 1.04.49 2.01.97 2.96.47.93 1.09 1.78 1.83 2.52s1.59 1.36 2.52 1.83c.95.48 1.92.79 2.96.98 1.03.18 2.07.25 3.11.27.48.01.95.02 1.43.02H181.02c.48 0 .95-.01 1.43-.02 1.04-.03 2.08-.09 3.11-.27 1.04-.19 2.01-.49 2.96-.98.93-.47 1.78-1.09 2.52-1.83s1.36-1.59 1.83-2.52c.48-.95.79-1.92.97-2.96.19-1.03.25-2.07.27-3.11.01-.48.02-.95.02-1.43V42.75c0-.48-.01-.95-.02-1.43-.03-1.04-.09-2.09-.27-3.11-.19-1.04-.49-2.01-.97-2.96a9.856 9.856 0 0 0-1.83-2.52 9.856 9.856 0 0 0-2.52-1.83c-.95-.48-1.92-.79-2.96-.98-1.03-.18-2.08-.25-3.11-.27-.48-.01-.96-.02-1.43-.02h-1.69z" />
    <path
      d="M179.33 33.16H181c.45 0 .91.01 1.36.02.79.02 1.72.06 2.58.22.75.14 1.38.34 1.98.65.6.3 1.14.7 1.62 1.18.48.48.88 1.03 1.18 1.63.31.6.51 1.23.64 1.98.15.85.2 1.78.22 2.58.01.45.02.9.02 1.36v79.67c0 .45-.01.9-.02 1.35-.02.8-.06 1.72-.22 2.59-.13.75-.34 1.37-.64 1.97-.31.6-.7 1.15-1.18 1.63s-1.02.88-1.63 1.18c-.6.31-1.23.51-1.97.65-.88.16-1.85.2-2.57.22-.46.01-.91.02-1.38.02H41.77c-.46 0-.91-.01-1.35-.02-.74-.02-1.71-.06-2.58-.22-.75-.13-1.38-.34-1.99-.65a6.474 6.474 0 0 1-2.8-2.8c-.31-.6-.51-1.23-.65-1.99-.16-.86-.2-1.79-.22-2.58-.01-.45-.02-.9-.02-1.35V42.77c0-.45.01-.9.02-1.36.02-.79.06-1.72.22-2.59.13-.75.34-1.38.65-1.98a6.474 6.474 0 0 1 2.8-2.8c.6-.31 1.23-.51 1.98-.65.86-.16 1.79-.2 2.58-.22.45-.01.91-.02 1.35-.02h137.57"
      style={{
        fill: '#fff',
      }}
    />
    <path d="M73.82 65.27c1.42-1.77 2.38-4.15 2.13-6.59-2.07.1-4.61 1.37-6.07 3.14-1.32 1.52-2.48 4-2.18 6.33 2.32.21 4.65-1.16 6.12-2.88M75.91 68.61c-3.38-.2-6.26 1.92-7.87 1.92-1.62 0-4.09-1.82-6.76-1.77-3.48.05-6.71 2.02-8.48 5.15-3.63 6.26-.96 15.55 2.57 20.66 1.72 2.52 3.78 5.3 6.51 5.2 2.57-.1 3.58-1.67 6.71-1.67s4.04 1.67 6.76 1.62c2.83-.05 4.59-2.53 6.31-5.05 1.97-2.88 2.77-5.65 2.83-5.81-.05-.05-5.45-2.12-5.5-8.33-.05-5.2 4.24-7.67 4.44-7.83-2.42-3.58-6.2-3.99-7.52-4.09M105.36 61.57c7.35 0 12.47 5.07 12.47 12.44 0 7.4-5.22 12.5-12.65 12.5h-8.14v12.94h-5.88V61.57h14.2zm-8.32 20.01h6.75c5.12 0 8.03-2.76 8.03-7.53 0-4.78-2.91-7.51-8.01-7.51h-6.77v15.04zM119.37 91.61c0-4.83 3.7-7.8 10.27-8.17l7.56-.45v-2.13c0-3.07-2.07-4.91-5.54-4.91-3.28 0-5.33 1.57-5.83 4.04h-5.36c.31-4.99 4.57-8.66 11.39-8.66 6.69 0 10.97 3.54 10.97 9.08v19.03h-5.43V94.9h-.13c-1.6 3.07-5.09 5.01-8.72 5.01-5.4.02-9.18-3.34-9.18-8.3zm17.83-2.5v-2.18l-6.8.42c-3.39.24-5.3 1.73-5.3 4.1 0 2.42 2 3.99 5.04 3.99 3.96 0 7.06-2.73 7.06-6.33zM147.97 109.62v-4.59c.42.1 1.36.1 1.84.1 2.63 0 4.04-1.1 4.91-3.94 0-.05.5-1.68.5-1.71l-9.98-27.65h6.14l6.98 22.47h.1l6.98-22.47h5.99L161.1 100.9c-2.36 6.7-5.09 8.85-10.82 8.85-.47 0-1.89-.05-2.31-.13z" />
  </svg>
)
